import * as jQuery from 'jquery';
import 'jquery-colorbox';

const colorboxDefaults = {
	transition: 'fade',
	fixed: true,
	width: 1280,
	height: 720,
	opacity: .75,
	scalePhotos: true,
	maxWidth: '95%',
	maxHeight: '95%',
	initialWidth: 500,
	initialHeight: 300,
	close: '<span>Close</span>'
};
const VideoLightbox = () => {
	const colorboxConfig = jQuery.extend({}, colorboxDefaults, {
		iframe: true,
		rel: false
	});

	//@ts-ignore
	jQuery('[href*="youtube.com/embed"], [href*="player.vimeo.com"]').colorbox(colorboxConfig);
};

export default VideoLightbox;
